export const getError = state => state.fullscreenLink.get('error')
export const getIsSubmitting = state => state.fullscreenLink.get('isSubmitting')
export const getIsLoaded = state => state.fullscreenLink.get('isLoaded')
export const getIsDataLoaded = state => state.fullscreenLink.get('isDataLoaded')
